import { render } from "./CreateAccountView.vue?vue&type=template&id=e96190ae"
import script from "./CreateAccountView.vue?vue&type=script&lang=js"
export * from "./CreateAccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__